import type { SxProps, Theme } from '@mui/material/styles';

/**
 * Listing rows stay one line tall. Long names and descriptions ellipsize
 * instead of wrapping and stretching the row.
 */
export const listingTableSx: SxProps<Theme> = {
  '& .MuiTableCell-head': {
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
  },
  '& .MuiTableCell-body:not([colspan])': {
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
  },
  '& .MuiTableCell-body:not([colspan]) .MuiTypography-root': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
};
